// Store simples (pub/sub) para o modal de loading de download. Necessário
// porque os helpers de download (downloadPdf.js) são funções puras, fora da
// árvore React — elas ligam/desligam esse estado, e o modal montado uma vez
// no layout escuta.
let listeners = [];
let active = false;

export function setDownloadLoading(value) {
  active = !!value;
  listeners.forEach((listener) => listener(active));
}

export function subscribeDownloadLoading(listener) {
  listeners.push(listener);
  listener(active);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}
